import styled from "@emotion/styled";
import React from "react";
import { Button, ButtonProps, CircularProgress } from "@mui/material";

function ButtonDefault(props: IButtonDefault) {
  const { show = true, isLoading } = props;
  if (!show) return <></>;
  if (isLoading)
    return (
      <ButtonCustom {...props} disabled>
        <SpinnerCustom />
      </ButtonCustom>
    );
  return <ButtonCustom {...props} />;
}

export interface IButtonDefault extends ButtonProps {
  show?: boolean;
  isLoading?: boolean;
}
export default ButtonDefault;

const SpinnerCustom = styled(CircularProgress)`
  svg {
    color: white;
    font-size: 1.5rem;
  }
`;

const ButtonCustom = styled(Button)`
  padding: 9px 17px;
  height: 48px;
  border-radius: 24px;
  min-width: 142px;
  font-size: ${12 / 16}rem;
  transition: 0.5s;
  &.--btn-bg-01 {
    background-color: var(--btn-bg-01);
    color: white;
    font-family: var(--FF-SF);
  }
  &.--btn-bg-02 {
    background-color: var(--btn-bg-02);
    color: white;
    font-family: var(--FF-SF);
  }
  &.--btn-bg-03 {
    background-color: var(--btn-bg-03);
    color: var(--color-blue-secondary);
    font-family: var(--FF-SF);
  }
  &:hover {
    transform: scale(1.03);
    transition: 0.5s;
  }
`;

//  --btn-bg-01: var(--color-blue-main);
//   --btn-bg-02: var(--color-blue-secondary);
//   --btn-bg-03: var(--color-gray-03);
//   --btn-bg-04: var(--color-blue-04);
